/*
 * This is the initial API interface
 * we set the base URL for the API
 */

import axios from "axios";
// import store from "../store";

export const apiClient = axios.create({
    // baseURL: "http://41.208.70.232/",
    // baseURL: "https://localhost:44384/",
    baseURL: "https://tahseen.growthtech.ly/",

    withCredentials: false, // required to handle the CSRF token
    // headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${store.state.auth.accessToken}`
    //         // Authorization: `Bearer ${ localStorage.getItem('䫀笢') }`
    // }
});

export const login = axios.create({
    // baseURL: "http://41.208.70.232/",
    // baseURL: "https://localhost:44384/",
    baseURL: "https://tahseen.growthtech.ly/",

    withCredentials: false, // required to handle the CSRF token
});